__webpack_require__.p = "/public/myinvestments/";